// flightSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getFlightSearchList } from '../../services/userservice';


export const fetchFlightCountryList = createAsyncThunk(
    'flight/fetchFlightCountryList',
    async ({ searchQuery, searchTerm }, { rejectWithValue }) => {
      try {
        const response = await getFlightSearchList(searchQuery, searchTerm);
        return response;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );

const flightCountryListSlice = createSlice({
    name: 'flightList',
    initialState: {
        flightList: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFlightCountryList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchFlightCountryList.fulfilled, (state, action) => {
                state.flightList = action.payload;
                state.loading = false;
            })
            .addCase(fetchFlightCountryList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default flightCountryListSlice.reducer;
